import { useOutlet } from "@/lib/outlet";
import { MapPin, ChevronDown } from "lucide-react";

/**
 * Compact outlet dropdown for the Procurement header — persistent per user
 * via localStorage. Selection filters every downstream tab.
 */
export default function OutletSwitcher() {
  const { outlet, setOutlet, outlets } = useOutlet();
  return (
    <label className="inline-flex items-center gap-2 border border-[hsl(var(--rule))] rounded-full pl-3 pr-1 py-1 bg-[hsl(var(--bg))]">
      <MapPin size={12} className="text-[hsl(var(--brass-2))]" />
      <span className="text-[10px] uppercase tracking-widest text-[hsl(var(--ink-soft))]">Outlet</span>
      <div className="relative flex items-center">
        <select
          data-testid="outlet-switcher"
          value={outlet}
          onChange={(e) => setOutlet(e.target.value)}
          className="pl-2 pr-6 py-0.5 text-[11px] uppercase tracking-widest bg-transparent border-0 focus:outline-none appearance-none cursor-pointer font-semibold text-[hsl(var(--forest))]"
        >
          {outlets.map((o) => (
            <option key={o.code} value={o.code}>{o.name}</option>
          ))}
        </select>
        <ChevronDown size={12} className="absolute right-1 pointer-events-none text-[hsl(var(--ink-soft))]" />
      </div>
    </label>
  );
}
